import { extendRequiredParameter } from "./apply.js";
import { metadataState } from "components/organisms/manuscript/overleaf/visual/language";
/**
 * Labels parsed from docs in the project, for cross-referencing
 */
export function buildLabelCompletions(completions, context) {
    const metadata = context.state.field(metadataState, false);
    if (!metadata) {
        return;
    }
    for (const label of metadata.labels) {
        completions.labels.push({
            type: "label",
            label,
            extend: extendRequiredParameter,
        });
    }
}
